import React from "react";

const Wrapper = ({ children, width, height, color, viewBox, className, style = "fill" }) => {
  return (
    <svg
      width={width || "26"}
      height={height || "26"}
      fill={style === "fill" ? color || "currentColor" : "none"}
      stroke={style === "stroke" ? color || "currentColor" : "none"}
      strokeWidth={2}
      viewBox={viewBox || "0 0 48 48"}
      className={className || ""}
    >
      {children}
    </svg>
  );
};

function AccountIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className}>
      <path d="M11.1 35.25q3.15-2.2 6.25-3.375Q20.45 30.7 24 30.7q3.55 0 6.675 1.175t6.275 3.375q2.2-2.7 3.125-5.45Q41 27.05 41 24q0-7.25-4.875-12.125T24 7q-7.25 0-12.125 4.875T7 24q0 3.05.95 5.8t3.15 5.45ZM24 25.5q-2.9 0-4.875-1.975T17.15 18.65q0-2.9 1.975-4.875T24 11.8q2.9 0 4.875 1.975t1.975 4.875q0 2.9-1.975 4.875T24 25.5ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.775t4.3-6.35q2.725-2.725 6.375-4.3Q19.9 4 24 4q4.15 0 7.775 1.575t6.35 4.3q2.725 2.725 4.3 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.3 6.375-2.725 2.725-6.35 4.3Q28.15 44 24 44Zm0-3q2.75 0 5.375-.8t5.175-2.8q-2.55-1.8-5.2-2.75-2.65-.95-5.35-.95-2.7 0-5.35.95-2.65.95-5.2 2.75 2.55 2 5.175 2.8Q21.25 41 24 41Zm0-18.5q1.7 0 2.775-1.075t1.075-2.775q0-1.7-1.075-2.775T24 14.8q-1.7 0-2.775 1.075T20.15 18.65q0 1.7 1.075 2.775T24 22.5Zm0-3.85Zm0 18.7Z" />
    </Wrapper>
  );
}

function RunnerIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className}>
      <path d="M26.75 46V34.05l-5.4-4.95-2.1 9.4L6 35.75l.55-2.8 9.95 2 3.65-18.45-5 2.35v6.7h-3V16.8l8.2-3.45q1.6-.7 2.275-.875Q23.3 12.3 24 12.3q1 0 1.775.425.775.425 1.325 1.275l2.1 3.35q1.3 2.1 3.55 3.65Q35 22.55 38 22.55v3q-3.35 0-5.975-1.55-2.625-1.55-4.875-4.65l-1.95 7.9 4.55 4.2V46ZM27 10.3q-1.5 0-2.575-1.075Q23.35 8.15 23.35 6.65q0-1.5 1.075-2.575Q25.5 3 27 3q1.5 0 2.575 1.075Q30.65 5.15 30.65 6.65q0 1.5-1.075 2.575Q28.5 10.3 27 10.3Z" />
    </Wrapper>
  );
}

function DeleteIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className}>
      <path d="M13.05 42q-1.25 0-2.125-.875T10.05 39V10.5H8v-3h9.4V6h13.2v1.5H40v3h-2.05V39q0 1.2-.9 2.1-.9.9-2.1.9Zm21.9-31.5h-21.9V39h21.9Zm-16.6 24.2h3V14.75h-3Zm8.3 0h3V14.75h-3Zm-13.6-24.2V39Z" />
    </Wrapper>
  );
}

function CalendarIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className}>
      <path d="M9 44q-1.2 0-2.1-.9Q6 42.2 6 41V10q0-1.2.9-2.1Q7.8 7 9 7h3.25V4h3.25v3h17V4h3.25v3H39q1.2 0 2.1.9.9.9.9 2.1v31q0 1.2-.9 2.1-.9.9-2.1.9Zm0-3h30V19.5H9V41Zm0-24.5h30V10H9Zm0 0V10v6.5ZM24 28q-.85 0-1.425-.575Q22 26.85 22 26q0-.85.575-1.425Q23.15 24 24 24q.85 0 1.425.575Q26 25.15 26 26q0 .85-.575 1.425Q24.85 28 24 28Zm-8 0q-.85 0-1.425-.575Q14 26.85 14 26q0-.85.575-1.425Q15.15 24 16 24q.85 0 1.425.575Q18 25.15 18 26q0 .85-.575 1.425Q16.85 28 16 28Zm16 0q-.85 0-1.425-.575Q30 26.85 30 26q0-.85.575-1.425Q31.15 24 32 24q.85 0 1.425.575Q34 25.15 34 26q0 .85-.575 1.425Q32.85 28 32 28Zm-8 8q-.85 0-1.425-.575Q22 34.85 22 34q0-.85.575-1.425Q23.15 32 24 32q.85 0 1.425.575Q26 33.15 26 34q0 .85-.575 1.425Q24.85 36 24 36Zm-8 0q-.85 0-1.425-.575Q14 34.85 14 34q0-.85.575-1.425Q15.15 32 16 32q.85 0 1.425.575Q18 33.15 18 34q0 .85-.575 1.425Q16.85 36 16 36Zm16 0q-.85 0-1.425-.575Q30 34.85 30 34q0-.85.575-1.425Q31.15 32 32 32q.85 0 1.425.575Q34 33.15 34 34q0 .85-.575 1.425Q32.85 36 32 36Z" />
    </Wrapper>
  );
}

function SprintIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className}>
      <path d="m10.8 40-2.1-2.1 20.4-20.4H22v4h-3v-7h11.15q.7 0 1.35.25.65.25 1.15.75l6 5.95q1.45 1.45 3.35 2.2 1.9.75 4 .85v3q-2.6-.1-5-.975T36.8 23.8l-2.3-2.3-5.7 5.7 4.3 4.3-12.2 7.05-1.5-2.6 8.8-5.1-4.1-4.1ZM6 26v-3h10v3Zm-4-6.5v-3h10v3Zm37.5-4q-1.45 0-2.475-1.025Q36 13.45 36 12q0-1.45 1.025-2.475Q38.05 8.5 39.5 8.5q1.45 0 2.475 1.025Q43 10.55 43 12q0 1.45-1.025 2.475Q40.95 15.5 39.5 15.5ZM6 13v-3h10v3Z" />
    </Wrapper>
  );
}
function MailIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className}>
      <path d="M7 40q-1.2 0-2.1-.9Q4 38.2 4 37V11q0-1.2.9-2.1Q5.8 8 7 8h34q1.2 0 2.1.9.9.9.9 2.1v26q0 1.2-.9 2.1-.9.9-2.1.9Zm17-15.1L7 13.75V37h34V13.75Zm0-3L40.8 11H7.25ZM7 13.75V11v26Z" />
    </Wrapper>
  );
}
function LocationIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className}>
      <path d="M24 23.5q1.45 0 2.475-1.025Q27.5 21.45 27.5 20q0-1.45-1.025-2.475Q25.45 16.5 24 16.5q-1.45 0-2.475 1.025Q20.5 18.55 20.5 20q0 1.45 1.025 2.475Q22.55 23.5 24 23.5Zm0 16.55q6.65-6.05 9.825-10.975Q37 24.15 37 20.4q0-5.9-3.775-9.65T24 7q-5.45 0-9.225 3.75Q11 14.5 11 20.4q0 3.75 3.25 8.675Q17.5 34 24 40.05ZM24 44q-8.05-6.85-12.025-12.725Q8 25.4 8 20.4q0-7.5 4.825-11.95Q17.65 4 24 4q6.35 0 11.175 4.45Q40 12.9 40 20.4q0 5-3.975 10.875T24 44Zm0-23.6Z" />
    </Wrapper>
  );
}

function ArrowBackIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className} viewBox="0 96 960 960">
      <path d="M448 606h152q13 0 21.5-8.5T630 576q0-13-8.5-21.5T600 546H448l53-53q9-9 9-21t-9-21q-9-9-21-9t-21 9L355 555q-9 9-9 21t9 21l104 104q9 9 21 9t21-9q9-9 9-21t-9-21l-53-53Zm32 370q-82 0-155-31.5t-127.5-86Q143 804 111.5 731T80 576q0-83 31.5-156t86-127Q252 239 325 207.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 82-31.5 155T763 858.5q-54 54.5-127 86T480 976Zm0-60q142 0 241-99.5T820 576q0-142-99-241t-241-99q-141 0-240.5 99T140 576q0 141 99.5 240.5T480 916Zm0-340Z" />
    </Wrapper>
  );
}

function ChevronLeftIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style || "stroke"}
      viewBox="0 0 24 24"
    >
      <path d="m15 18-6-6 6-6" />
    </Wrapper>
  );
}

function UsersIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style || "stroke"}
      viewBox="0 0 24 24"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
    </Wrapper>
  );
}

function TruckIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className} viewBox="0 96 960 960">
      <path d="M224.118 895Q175 895 140.5 860.583 106 826.167 106 777H40V316q0-24 18-42t42-18h579v167h105l136 181v173h-71q0 49.167-34.382 83.583Q780.235 895 731.118 895 682 895 647.5 860.583 613 826.167 613 777H342q0 49-34.382 83.5-34.383 34.5-83.5 34.5ZM224 835q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17ZM100 717h22q17-27 43.041-43 26.041-16 58-16t58.459 16.5Q308 691 325 717h294V316H100v401Zm631 118q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm-52-204h186L754 483h-75v148ZM360 527Z" />
    </Wrapper>
  );
}

function CopyIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className} viewBox="0 -960 960 960">
      <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
    </Wrapper>
  );
}

function MedalIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className} viewBox="0 -960 960 960">
      <path d="m387-412 35-114-92-74h114l36-112 36 112h114l-93 74 35 114-92-71-93 71ZM240-40v-309q-38-42-59-96t-21-115q0-134 93-227t227-93q134 0 227 93t93 227q0 61-21 115t-59 96v309l-240-80-240 80Zm240-280q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70ZM320-159l160-41 160 41v-124q-35 20-75.5 31.5T480-240q-44 0-84.5-11.5T320-283v124Zm160-62Z" />
    </Wrapper>
  );
}

function ClockIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className} viewBox="0 -960 960 960">
      <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z" />
    </Wrapper>
  );
}

function EventAvailableIcon(props) {
  return (
    <Wrapper width={props?.size} height={props?.size} color={props?.color} className={props?.className} viewBox="0 -960 960 960">
      <path d="M438-226 296-368l58-58 84 84 168-168 58 58-226 226ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
    </Wrapper>
  );
}

function PaperPlaneIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 0 24 24"
    >
      <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
      <path d="m21.854 2.147-10.94 10.939" />
    </Wrapper>
  );
}

function HeartIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 0 24 24"
    >
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </Wrapper>
  );
}

function TextBubbleIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 0 24 24"
    >
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    </Wrapper>
  );
}

function ChatIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style || "stroke"}
      viewBox="0 0 24 24"
    >
      <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
      <path d="M8 9h8" />
      <path d="M8 13h5" />
    </Wrapper>
  );
}

function BellIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z" />
    </Wrapper>
  );
}

function MenuDotsIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="M200-400q-33 0-56.5-23.5T120-480q0-33 23.5-56.5T200-560q33 0 56.5 23.5T280-480q0 33-23.5 56.5T200-400Zm280 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm280 0q-33 0-56.5-23.5T680-480q0-33 23.5-56.5T760-560q33 0 56.5 23.5T840-480q0 33-23.5 56.5T760-400Z" />
    </Wrapper>
  );
}



function CameraIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="M440-440ZM120-120q-33 0-56.5-23.5T40-200v-480q0-33 23.5-56.5T120-760h160l80-80h240l80 80h160q33 0 56.5 23.5T920-680v480q0 33-23.5 56.5T840-120H120Zm0-80h720v-480H766l-80-80H274l-80 80H120v480Zm360-80q75 0 127.5-52.5T660-460q0-75-52.5-127.5T480-640q-75 0-127.5 52.5T300-460q0 75 52.5 127.5T480-280Zm0-80q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29Z" />
    </Wrapper>
  );
}

function GraphIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
    </Wrapper>
  );
}

function HashtagIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="m260-200 40-160h-80v-80h80l20-80h-80v-80h80l40-160h80l-40 160h120l40-160h80l-40 160h80v80h-80l-20 80h80v80h-80l-40 160h-80l40-160H340l-40 160h-80Zm100-240h120l20-80H380l-20 80Z" />
    </Wrapper>
  );
}

function SearchIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style || "stroke"}
      viewBox="0 0 24 24"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.35-4.35" />
    </Wrapper>
  );
}

function ListIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="M280-600v-80h560v80H280Zm0 160v-80h560v80H280Zm0 160v-80h560v80H280ZM160-600q-17 0-28.5-11.5T120-640q0-17 11.5-28.5T160-680q17 0 28.5 11.5T200-640q0 17-11.5 28.5T160-600Zm0 160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520q17 0 28.5 11.5T200-480q0 17-11.5 28.5T160-440Zm0 160q-17 0-28.5-11.5T120-320q0-17 11.5-28.5T160-360q17 0 28.5 11.5T200-320q0 17-11.5 28.5T160-280Z" />
    </Wrapper>
  );
}

function PlaygroundIcon(props) {
  return (
    <svg
      width={props?.size || "26"}
      height={props?.size || "26"}
      fill="none"
      stroke={props?.color || "currentColor"}
      strokeWidth="2"
      className={props?.className}
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 21V4h7v5M5 8h7M5 13h4M9 9l10 12M9 21h10" />
    </svg>
  );
}

function SparklesIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="M480-80q-17 0-28.5-11.5T440-120q0-17 11.5-28.5T480-160q17 0 28.5 11.5T520-120q0 17-11.5 28.5T480-80Zm-80-160q-17 0-28.5-11.5T360-280q0-17 11.5-28.5T400-320q17 0 28.5 11.5T440-280q0 17-11.5 28.5T400-240Zm160 0q-17 0-28.5-11.5T520-280q0-17 11.5-28.5T560-320q17 0 28.5 11.5T600-280q0 17-11.5 28.5T560-240ZM320-400q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm160 0q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm160 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM240-560q-17 0-28.5-11.5T200-600q0-17 11.5-28.5T240-640q17 0 28.5 11.5T280-600q0 17-11.5 28.5T240-560Zm160 0q-17 0-28.5-11.5T360-600q0-17 11.5-28.5T400-640q17 0 28.5 11.5T440-600q0 17-11.5 28.5T400-560Zm160 0q-17 0-28.5-11.5T520-600q0-17 11.5-28.5T560-640q17 0 28.5 11.5T600-600q0 17-11.5 28.5T560-560Zm160 0q-17 0-28.5-11.5T680-600q0-17 11.5-28.5T720-640q17 0 28.5 11.5T760-600q0 17-11.5 28.5T720-560ZM320-720q-17 0-28.5-11.5T280-760q0-17 11.5-28.5T320-800q17 0 28.5 11.5T360-760q0 17-11.5 28.5T320-720Zm160 0q-17 0-28.5-11.5T440-760q0-17 11.5-28.5T480-800q17 0 28.5 11.5T520-760q0 17-11.5 28.5T480-720Zm160 0q-17 0-28.5-11.5T600-760q0-17 11.5-28.5T640-800q17 0 28.5 11.5T680-760q0 17-11.5 28.5T640-720Z" />
    </Wrapper>
  );
}

function DumbbellIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="M760-440H200v-80h560v80ZM160-320v-320h80v320h-80Zm80-80h80v-160h-80v160Zm480 80v-320h80v320h-80Zm-80-80h80v-160h-80v160Z" />
    </Wrapper>
  );
}

function MomentumIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 0 48 48"
    >
      <path d="M20.4 44 23 29.7H12L27.6 4H30l-2.6 16.7H38Z" />
    </Wrapper>
  );
}

function CloseIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style}
      viewBox="0 -960 960 960"
    >
      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </Wrapper>
  );
}

function ChainIcon(props) {
  return (
    <Wrapper
      width={props?.size}
      height={props?.size}
      color={props?.color}
      className={props?.className}
      style={props?.style || "stroke"}
      viewBox="0 0 24 24"
    >
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </Wrapper>
  );
}

export {
  AccountIcon,
  BellIcon,
  RunnerIcon,
  SprintIcon,
  DeleteIcon,
  CalendarIcon,
  MailIcon,
  LocationIcon,
  ArrowBackIcon,
  ChevronLeftIcon,
  UsersIcon,
  TruckIcon,
  CopyIcon,
  MedalIcon,
  ClockIcon,
  EventAvailableIcon,
  PaperPlaneIcon,
  HeartIcon,
  TextBubbleIcon,
  ChatIcon,
  MenuDotsIcon,
  CameraIcon,
  GraphIcon,
  HashtagIcon,
  SearchIcon,
  CloseIcon,
  ListIcon,
  PlaygroundIcon,
  SparklesIcon,
  DumbbellIcon,
  MomentumIcon,
  ChainIcon,
};
